import { cn } from "@/lib/cn";

/** Visualizes how much of one ownership pool (the borrower company, or a
 * single business shareholder's own owners) has been declared so far —
 * mirrors the admin panel's shareholder coverage bar. */
export function CoverageBar({ label, total }: { label: string; total: number }) {
  const full = total >= 100;
  const fillWidth = Math.min(Math.max(total, 0), 100);

  return (
    <div className="flex flex-col gap-1.5">
      <div className="flex items-baseline justify-between gap-2">
        <span className="text-xs font-semibold text-ink">{label}</span>
        <span className="text-xs text-muted">{total.toFixed(2)}% declared</span>
      </div>
      <div className="relative h-2.5 rounded-full bg-line">
        <div
          className={cn(
            "absolute inset-y-0 left-0 rounded-full transition-[width]",
            full ? "bg-success" : "bg-brand",
          )}
          style={{ width: `${fillWidth}%` }}
        />
      </div>
      {full ? <p className="text-[11px] text-success">100% allocated — fully declared.</p> : null}
    </div>
  );
}
